import { isStudioModuleEntitled } from "./studioModules";

/** Care & Preservation (studio side). The certificate shows care whenever the server sends it. */
export const isCareEnabled = (): boolean =>
  process.env.REACT_APP_CARE_ENABLED === "true" || process.env.REACT_APP_ENV === "loc";

const isStudioStaff = (role?: string): boolean =>
  role === "SUPER_ADMIN" || role === "ORGANIZATION_ADMIN" || role === "ORGANIZATION_MANAGER";

export const canUseCare = (role?: string): boolean => {
  if (!isCareEnabled() || !isStudioStaff(role)) return false;
  return role === "SUPER_ADMIN" || isStudioModuleEntitled("CARE");
};
